var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppdeviationDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    rx: 10,
    fill: "#F3F3F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 3.41663C6.58999 3.41663 3.41666 6.58996 3.41666 10.5C3.41666 14.41 6.58999 17.5833 10.5 17.5833C14.41 17.5833 17.5833 14.41 17.5833 10.5C17.5833 6.58996 14.41 3.41663 10.5 3.41663ZM10.5 16.1666C7.37624 16.1666 4.83332 13.6237 4.83332 10.5C4.83332 7.37621 7.37624 4.83329 10.5 4.83329C13.6237 4.83329 16.1667 7.37621 16.1667 10.5C16.1667 13.6237 13.6237 16.1666 10.5 16.1666ZM13.4537 12.455L12.6746 11.6758C13.1775 10.7337 13.05 9.54371 12.2567 8.75038C11.7679 8.26163 11.1375 8.02079 10.5 8.02079C10.4787 8.02079 10.4575 8.02788 10.4362 8.02788L11.2083 8.79996L10.4575 9.55079L8.45291 7.54621L10.4575 5.54163L11.2083 6.29246L10.5283 6.97246C11.4279 6.97954 12.3204 7.31246 13.0075 7.99246C14.2117 9.20371 14.3604 11.0808 13.4537 12.455ZM12.5471 13.4537L10.5425 15.4583L9.79166 14.7075L10.4646 14.0345C9.57207 14.0275 8.67957 13.6804 7.99957 13.0004C6.78832 11.7891 6.63957 9.91913 7.54624 8.54496L8.32541 9.32413C7.82249 10.2662 7.94999 11.4562 8.74332 12.2495C9.23916 12.7454 9.89791 12.9862 10.5567 12.965L9.79166 12.2L10.5425 11.4491L12.5471 13.4537Z",
    fill: "#68778D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppdeviationDone);
export default __webpack_public_path__ + "static/media/app.deviation_done.98d9ddf43852e87197bba3a61b682329.svg";
export { ForwardRef as ReactComponent };